import React from 'react'

export default function InRowHeadingContent({heading,content,className=""}) {
    return (
        <div className={"d-flex align-content-center "+className}>
            <div className="heading me-4">
                <h6>{heading}</h6>
            </div>
            <div className="heading-content">
                {content}
            </div>
        </div>
    )
}
